export class InitiateAccountSwitchRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "eonAccountId",
            "baseName": "eonAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "roleId",
            "baseName": "roleId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InitiateAccountSwitchRequest.attributeTypeMap;
    }
    constructor() {
    }
}
